import React from 'react'
import './style.scss'

export default function Checkbox({ id, onChange }) { 

    const handleChange = (e) => {
        onChange()
    }

    return (
        <>
        <label class="container calibri">
            <input onChange={handleChange} id={id} type="checkbox"/>
            <span class="checkmark"></span>
        </label>
        </>
    )
}